import { useCallback, useRef, useContext } from 'react';
import { MapContext } from '../maps/MapContext';
import { fetchPlaceDetails } from './PlaceDetailsService';
import useApi from '../../Api';
import { useAuth } from '../../AuthContext';

const usePlaceDetailsWrapper = () => {
  const { googleMapsAPI } = useContext(MapContext);
  const apiClient = useApi();
  const fetchPlaceDetailsTimeout = useRef(null);

  const fetchPlaceDetailsWrapper = useCallback(
    (placeId) => {
      if (!googleMapsAPI || !placeId) return Promise.resolve(null);
      if (fetchPlaceDetailsTimeout.current) {
        clearTimeout(fetchPlaceDetailsTimeout.current);
      }
      return new Promise((resolve) => {
        fetchPlaceDetailsTimeout.current = setTimeout(async () => {
          const details = await fetchPlaceDetails(googleMapsAPI, placeId, apiClient);
          resolve(details);
        }, 150);
      });
    },
    [googleMapsAPI, apiClient]
  );

  return { fetchPlaceDetailsWrapper };
};

export default usePlaceDetailsWrapper;
